<template>
  <DnsList />
</template>

<script>
// @ is an alias to /src
import DnsList from "../components/DnsList.vue";

export default {
name: "DnsLists",
  components: {
    DnsList,
  },
  
};
</script>
